import './style.scss';

// video読込判定
document.addEventListener('DOMContentLoaded', function () {
    function loadSectionVideos() {
        var videos = document.querySelectorAll(
            '.wp-block-lpc-blocks-section .lpcb-section__media[data-src]'
        );
        var width = window.innerWidth;

        videos.forEach(function (video) {
            // すでに src が付いているなら何もしない
            if (video.getAttribute('src')) {
                return;
            }
            // data-srcがなければ何もしない
            var src = video.getAttribute('data-src');
            if (!src) {
                return;
            }

            // video が属しているセクションから表示設定クラス取得
            var wrapper = video.closest('.wp-block-lpc-blocks-section');
            var isHidePc      = wrapper.classList.contains('lpcb-hide-pc');
            var isHideTablet  = wrapper.classList.contains('lpcb-hide-tablet');
            var isHideSp      = wrapper.classList.contains('lpcb-hide-sp');

            // 現在の幅からデバイス帯判定
            var isPcWidth     = width >= 992;
            var isTabletWidth = width >= 768 && width <= 991;
            var isSpWidth     = width <= 767;
    
            // 今のデバイス帯で非表示指定されているなら何もしない
            if (isPcWidth && isHidePc) {
                return;
            }
            if (isTabletWidth && isHideTablet) {
                return;
            }
            if (isSpWidth && isHideSp) {
                return;
            }

            // videoをセット
            video.setAttribute('src', src);

            // 明示的に動画をロードする
            video.load();
        });
    }
    loadSectionVideos();

    // 画面回転などに対応
    window.addEventListener('resize', function () {
        loadSectionVideos();
    });
});
